import { BaseError } from '../../errors/base';

/**
 * This error is thrown when the `retryOnFail` function is called with an invalid
 * number of retries (i.e. less than 0).
 */
export class InvalidRetryOnFailCallError extends BaseError {
  constructor(maxRetries: number) {
    super({
      cause: null,
      code: 'invalid_retry_on_fail_call_error',
      docsUrl: null,
      name: 'InvalidRetryOnFailCallError',
      shortMessage: `Invalid retries parameter for retryOnFail call: ${maxRetries}`,
    });
  }
}
